function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{clip-path:url(#SVGID_2_);}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  width: 512,
  height: 512
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M400,244.8c-61.8,0-112,50.2-112,112s50.2,112,112,112c61.8,0,112-50.2,112-112S461.8,244.8,400,244.8  M400,451.7c-52.3,0-94.9-42.6-94.9-94.9c0-52.3,42.6-94.9,94.9-94.9c52.3,0,94.9,42.6,94.9,94.9 C494.9,409.1,452.3,451.7,400,451.7 M391.5,335.5v3.5c0,3.8,2.4,7,6,8.1l10.2,3.2c10.7,3.4,18,13.2,18,24.4v3.5 c0,12.3-8.7,22.6-20.3,25v2.7c0,4.7-3.8,8.5-8.5,8.5c-4.7,0-8.5-3.8-8.5-8.5v-5c-8.2-4.3-13.9-12.9-13.9-22.7 c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5v-3.5c0-3.8-2.4-7-6-8.1l-10.2-3.2 c-10.7-3.4-18-13.2-18-24.4v-3.5c0-11.1,7.1-20.6,17.1-24.1v-3.6c0-4.7,3.8-8.5,8.5-8.5c4.7,0,8.5,3.8,8.5,8.5v3.6 c9.9,3.5,17.1,13,17.1,24.1c0,4.7-3.8,8.5-8.5,8.5c-4.7,0-8.5-3.8-8.5-8.5c0-4.7-3.8-8.5-8.5-8.5 C395.3,326.9,391.5,330.8,391.5,335.5 M259.2,354c0,4.7-3.8,8.5-8.5,8.5H34.1C15.3,362.6,0,347.3,0,328.4V77.3 c0-18.8,15.3-34.1,34.1-34.1h412.8c18.8,0,34.1,15.3,34.1,34.1v149c0,4.7-3.8,8.5-8.5,8.5c-4.7,0-8.5-3.8-8.5-8.5v-149 c0-9.4-7.7-17.1-17.1-17.1H34.1c-9.4,0-17.1,7.7-17.1,17.1v251.1c0,9.4,7.7,17.1,17.1,17.1h216.5 C255.4,345.5,259.2,349.3,259.2,354 M160.5,202.9c0,44.1,35.9,80,80,80s80-35.9,80-80c0-44.1-35.9-80-80-80 S160.5,158.8,160.5,202.9 M303.5,202.9c0,34.7-28.2,62.9-62.9,62.9s-62.9-28.2-62.9-62.9c0-34.7,28.2-62.9,62.9-62.9 S303.5,168.2,303.5,202.9 M111.6,194.4c4.7,0,8.5,3.8,8.5,8.5c0,4.7-3.8,8.5-8.5,8.5H77.5c-4.7,0-8.5-3.8-8.5-8.5 c0-4.7,3.8-8.5,8.5-8.5H111.6z M403.5,194.4c4.7,0,8.5,3.8,8.5,8.5c0,4.7-3.8,8.5-8.5,8.5h-34.1c-4.7,0-8.5-3.8-8.5-8.5 c0-4.7,3.8-8.5,8.5-8.5H403.5z"
});

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", null, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.b6853f4f.svg";
export { ForwardRef as ReactComponent };